const broadcastMessageEnum = Object.freeze({
  FACEBOOK_POPUP: '@broadcast/PAYMENT_POPUP_RESP_KEY',
  PAYMENT_POPUP: '@broadcast/FACEBOOK_POPUP_RESP_KEY',
});

export default broadcastMessageEnum;
